let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("kWrFZ"), load("hPzOn"), load("h2MrD"), load("bYT2S"), load("dsiAd"), load("4KqZA")]).then(() => parcelRequire('5tdjr'));